import React from 'react';
import { Link } from 'react-router-dom';

export const QuestionarioCasasSuccess = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4" data-testid="questionario-casas-success-screen">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-lg w-full text-center" data-testid="questionario-casas-success-card">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-testid="questionario-casas-success-icon">
          <span className="text-4xl">✅</span>
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-4" data-testid="questionario-casas-success-title">Solicitação enviada!</h2>
        <p className="text-gray-600 mb-6" data-testid="questionario-casas-success-message">
          Recebemos seu questionário de casas/reforma/painel solar. Nossa equipe entrará em contato em breve.
        </p>
        <div className="flex gap-3" data-testid="questionario-casas-success-actions">
          <Link to="/" className="flex-1 px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition" data-testid="questionario-casas-success-home-link">
            Voltar ao site
          </Link>
          <Link to="/desenhar-planta" className="flex-1 px-4 py-3 border border-blue-600 text-blue-600 rounded-lg hover:bg-blue-50 transition" data-testid="questionario-casas-success-editor-link">
            Desenhar planta
          </Link>
        </div>
      </div>
    </div>
  );
};
